import type { Language } from '@eformulieren/engine'
import { type LoginState, LoginScreen, LanguageSwitch } from '@eformulieren/renderer'
import { type ReactNode, useEffect } from 'react'
import { ProductBar } from './ProductBar.js'

/**
 * De pagina bij een directe link naar een formulier zonder sessie voor deze publicatie (R-154,
 * R-203, G017, opdracht 5c).
 *
 * Een knop per ingang naar de inlogdienst (`inloggen.ts`), of een storing als de pod niet kon
 * vaststellen of er een sessie is. Met de productbalk en de taalwissel, zoals de pagina van een
 * uitnodiging: wie hier komt, ziet al het product en kan de taal kiezen (R-144). Het formulier
 * zelf staat er niet, ook niet leeg (valkuil 6). De taalwissel is dezelfde NL/EN als in de kopbalk
 * van het formulier (audit R-40).
 */
export interface LoginPageProps {
  readonly taal: Language
  readonly onLanguage: (language: Language) => void
  readonly stand: LoginState
  readonly onAgain: () => void
}

export function LoginPage({ taal: language, onLanguage, stand: state, onAgain }: LoginPageProps): ReactNode {
  // De paginatitel zegt waar de lezer is (WCAG 2.4.2); eerder stond ook hier "Formulier".
  useEffect(() => {
    document.title = language === 'nl' ? 'Inloggen · NWO' : 'Sign in · NWO'
  }, [language])
  return (
    <>
      <ProductBar taal={language} actions={<LanguageSwitch taal={language} onLanguage={onLanguage} compact />} />
      <div className="pod-inloggen" data-proef="inloggen" data-stand={state.soort}>
        <LoginScreen taal={language} stand={state} onAgain={onAgain} />
      </div>
    </>
  )
}
